import type { ChangeFormField } from '../../types/changes';

export const DEFAULT_INTERNAL_SUBTASK_FORM_TABS = [
  'Anotações',
  'Informações de Fechamento',
] as const;

export type InternalFormTabsPosition = 'before' | 'after';

export function normalizeFormTabsPosition(
  value?: string | null,
): InternalFormTabsPosition {
  return value === 'before' ? 'before' : 'after';
}

export function normalizeFormTabs(tabs?: Array<string | null | undefined> | null): string[] {
  const names: string[] = [];
  for (const item of tabs || []) {
    const name = (item || '').trim();
    if (name && !names.includes(name)) names.push(name);
  }
  return names;
}

export function groupFieldsByFormTab(
  fields: ChangeFormField[],
  tabs: string[] = [],
): { main: ChangeFormField[]; tabs: Array<{ name: string; fields: ChangeFormField[] }> } {
  const names = normalizeFormTabs([
    ...tabs,
    ...fields.map((field) => field.section_name),
  ]);
  return {
    main: fields.filter((field) => !(field.section_name || '').trim()),
    tabs: names.map((name) => ({
      name,
      fields: fields.filter((field) => (field.section_name || '').trim() === name),
    })),
  };
}
